import Vue from 'vue'
import Vuex from 'vuex'

import menu from './menu'
import patient from './patient'
import snackbar from './snackbar'
import session from './session'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { 
    solution: '',
    successMessage: '',
    errorMessage: '',
    titulo: '',
    address: '',
    menu: ''
  },

  getters: {
    getSolution(state){
      return state.solution
    },

    getUser(state) {
      return state.authUser
    },
  },
  mutations: {
    setSolution(state, data){
      state.solution = data
    }, 
  },
  actions: {
    sendSolution(context, data) {
      context.commit('setSolution', data);
    }
  },
  
  modules: {
    menu,
    patient,
    snackbar,
    session
  }
})
